import { SkillDiscoveryItem } from '@gmm/sdk-voodoo/skillDiscovery/show';
import { isExerciseType } from '@gmm/ui';
import create from 'zustand';
import { devtools } from 'zustand/middleware';

interface ExerciseLastUpdatedState {
  // exercise id -> lastUpdated
  map: Map<string, number>;
  getLastUpdated: (exerciseId: string) => number;
  setLastUpdated: (items: SkillDiscoveryItem[]) => void;
  existedPriorToLockedExamFeature: (exerciseId: string | null) => boolean;
}

export const useExerciseLastUpdatedStore = create<ExerciseLastUpdatedState>()(
  devtools(
    (set, get) => ({
      map: new Map(),

      getLastUpdated: (exerciseId: string) => {
        return get().map.get(exerciseId) || 0;
      },

      setLastUpdated: (items: SkillDiscoveryItem[]) => {
        const newMap = new Map(get().map);
        items.forEach(item => {
          if (isExerciseType(item)) {
            newMap.set(item.id, item.lastUpdated);
          }
        });
        set({ map: newMap });
      },

      existedPriorToLockedExamFeature: (exerciseId: string | null) => {
        if (!exerciseId) return false;

        const lastUpdated = get().map.get(exerciseId);
        return !lastUpdated || lastUpdated < 1;
      },
    }),
    { name: 'ExerciseLastUpdatedStore' },
  ),
);
